import { NgModule } from '@angular/core';

import { CdwOuCollectionPickerComponent } from './cdw-ou-collection-picker/cdw-ou-collection-picker.component';

@NgModule({
  imports: [CdwOuCollectionPickerComponent],
  exports: [CdwOuCollectionPickerComponent],
})
export class CdwOuCollectionPickerModule {}
